import { Button } from '../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Smartphone } from 'lucide-react';
import { QRCodeCanvas } from 'qrcode.react';

export function QRPaymentDialog({ open, onOpenChange, qrPaymentData, onCheckPayment, paymentChecking }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-center flex items-center justify-center gap-2">
            <Smartphone className="w-5 h-5 text-blue-600" />
            Scan to Pay
          </DialogTitle>
        </DialogHeader>
        {qrPaymentData && (
          <div className="space-y-4">
            <div className="flex justify-center p-4 bg-white rounded-lg border-2 border-blue-100">
              <QRCodeCanvas
                value={qrPaymentData.qr_code_data}
                size={200}
                level="H"
                includeMargin={true}
              />
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-navy-900">Rs.{qrPaymentData.bill.grand_total}</p>
              <p className="text-sm text-slate-500">Bill: {qrPaymentData.bill_number}</p>
            </div>
            <div className="p-3 bg-blue-50 rounded-lg">
              <p className="text-xs text-blue-700 text-center">
                Ask customer to scan QR with any UPI app (GPay, PhonePe, Paytm)
              </p>
            </div>
            <div className="flex gap-2">
              <Button
                className="flex-1 bg-mint-600 hover:bg-mint-700"
                onClick={onCheckPayment}
                disabled={paymentChecking}
              >
                {paymentChecking ? 'Checking...' : 'Check Payment'}
              </Button>
              <Button
                variant="outline"
                className="flex-1"
                onClick={function() { onOpenChange(false); }}
              >
                Cancel
              </Button>
            </div>
            <p className="text-xs text-slate-400 text-center">
              Bill has been created. Close this if customer pays in cash instead.
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
